import { Component, OnInit } from '@angular/core';
import {environment} from "../../../environments/environment";
import {HttpService} from "../../services/http.service";
import {ColDef, GetContextMenuItemsParams, GridReadyEvent, IServerSideGetRowsParams, RowNode} from "ag-grid-community";
import {AiStructureCellComponent} from "../../grid/cell/ai-structure-cell/ai-structure-cell.component";
import {
  AiTuneSettingsDialogComponent
} from "../../grid/dialogs/ai-tune-settings-dialog/ai-tune-settings-dialog.component";
import {MatDialog} from '@angular/material/dialog';
import {AiSettingsDialogComponent} from "../../grid/dialogs/ai-settings-dialog/ai-settings-dialog.component";
import {GridService} from "../../services/grid.service";

@Component({
  selector: 'app-grid-ai-tags',
  templateUrl: './grid-ai-tags.component.html',
  styleUrls: ['./grid-ai-tags.component.scss']
})
export class GridAiTagsComponent implements OnInit {
  public gridApi: any;
  public columnApi: any;

  activeTitle: string = 'HVAC -> Controls -> Control Valves';
  collections: any = [];
  chips: any = [];
  activeChipElement: any = '';
  selectedCollection: any = 'HVAC -> Controls -> Control Valves';

  defaultColDef: ColDef = {
    flex: 1,
    minWidth: 170,
    resizable: true,
  };

  public columnDefs: ColDef[] = [
    {
      field: '_id',
      headerName: 'id',
      hide: true,
      editable: false,
      filter: 'agTextColumnFilter',
      suppressFiltersToolPanel: true,
      suppressColumnsToolPanel: true,
    },
    {
      field: 'sku',
      headerName: 'sku',
    },
    {
      field: 'ai_tags.step_1',
      headerName: 'step_1',
      editable: true,
      cellEditor: 'agLargeTextCellEditor',
    },
    {
      field: 'ai_tags.step_2',
      headerName: 'step_2',
      editable: true,
      cellEditor: 'agLargeTextCellEditor',
    },
    {
      field: 'ai_tags.step_3',
      headerName: 'step_3',
      editable: true,
      cellEditor: 'agLargeTextCellEditor',
    },
    {
      field: 'ai_tags.step_4',
      headerName: 'step_4',
      editable: true,
      cellEditor: 'agLargeTextCellEditor',
    },
    {
      field: 'brand.name',
      headerName: 'brand',
    },
    {
      field: 'handle',
      headerName: 'handle',
      hide: true,
    },
    {
      field: 'collections',
      headerName: 'Collections',
      cellRenderer: AiStructureCellComponent,
      minWidth: 570,
    },
    {
      field: 'product_id',
      headerName: 'Product ID',
      // hide: true,
      filter: 'agTextColumnFilter',
      minWidth: 250,
      editable: false,
      filterParams: {
        suppressAndOrCondition: true,
      },
    },
    {
      field: 'description',
      headerName: 'description',
    },
    {
      field: 'body_seo',
      headerName: 'body',
    },
    {
      field: 'body_prefix_1',
    },
    {
      field: 'body_prefix_2',
    },
    {
      field: 'body_prefix_3',
    },
    {
      field: 'body_suffix_1',
    },
    {
      field: 'body_suffix_2',
    },
    {
      field: 'body_suffix_3',
    }
  ];

  constructor(
    private httpService: HttpService,
    private dialog: MatDialog,
    private gridService: GridService
  ) { }

  ngOnInit(): void {
    this.httpService.get(environment.API_PATH + '/ai/get-all-collections').subscribe((response: any) => {
      console.log('collections', response);
      this.collections = response.sort((a: any, b: any) => {
        return a.title < b.title ? -1 : a.title > b.title ? 1 : 0;
      });
      this.chips = [];
      this.selectedCollection.split(' -> ').forEach((element: any) => {
        this.chips.push(element);
      });
      this.activeTitle = this.selectedCollection;
      this.activeChipElement = this.selectedCollection.split(' -> ').slice(-1)[0];
    })
  }

  onCollectionChange(event: any): void {
    this.chips = [];
    const value = event.value;
    value.split(' -> ').forEach((element: any) => {
      this.chips.push(element);
    });
    this.activeTitle = value;
    this.activeChipElement = value.split(' -> ').slice(-1)[0];
    this.gridService.aiTagsGridApi?.refreshServerSide();
  }

  onChipClick(event: any, index: number): void {
    this.activeChipElement = event;
    this.activeTitle = this.chips.slice(0, index + 1).join(' -> ');
    this.gridService.aiTagsGridApi?.refreshServerSide();
  }

  getGptContextMenuItems = (params: GetContextMenuItemsParams) => {
    return [
      {
        name: 'Open Shopify page',
        disabled: false,
        icon: '<span class="ag-icon ag-icon-eye" unselectable="on" role="presentation"></span>',
        action: () => {
          window.open('https://blackhawksupply.com/products/' + params?.node?.data.handle, '_blank');
        }
      },
      'separator',
      'export',
    ];
  }

  aiSettings() {
    this.dialog.open(AiSettingsDialogComponent, {
      autoFocus: false,
      width: '90%',
      height: '98%',
      // maxWidth: '800px',
      // maxHeight: '800px',
      disableClose: true,
      data: {},
      panelClass: 'ai-settings-tags'
    });
  }

  onSelectionChanged($event: any): void {
    const selectedRows: any = this.gridApi?.getSelectedRows();
    console.log('selectedRows', selectedRows);
  }

  runFiltered(stepIndex: number) {
    let filterModel = this.gridService.aiTagsGridApi?.getFilterModel();
    const body = {startRow: 0, endRow: 100, step: stepIndex, title: this.activeTitle, rowGroupCols: [], groupKeys: [], filterModel, sortModel: []};
    this.httpService.post(environment.API_PATH + '/ai/get-tags-for-filtered', body).subscribe((res: any) => {

    });
  }

  runSelection(stepIndex: number) {
    const selectedRows: any = this.gridService.aiTagsGridApi?.getSelectedRows();
    const selectedIds = selectedRows.map((x: any) => x.product_id);

    this.gridService.aiTagsGridApi?.showLoadingOverlay();
    this.httpService.post(environment.API_PATH + '/ai/get-tags-for-selected', {ids: selectedIds, step: stepIndex}).subscribe((res: any) => {
      if (res.error) {
        this.gridService.aiTagsGridApi?.hideOverlay();
      } else {
        // this.gridService.aiTagsGridApi?.deselectAll();
        this.gridService.aiTagsGridApi?.hideOverlay();
      }
    });
  }

  onGridReady(params: GridReadyEvent) {
    this.gridService.aiTagsGridApi = params.api;
    this.columnApi = params.columnApi;

    const that = this;

    this.gridService.aiTagsGridApi.setServerSideDatasource({
      getRows(params: IServerSideGetRowsParams) {
        const {startRow, endRow, rowGroupCols, groupKeys, filterModel, sortModel} = params.request;
        const body = {startRow, endRow, rowGroupCols, groupKeys, filterModel, sortModel, title: that.activeTitle};
        that.httpService.post(environment.API_PATH + '/ai/get-all-products-collections', body).subscribe((dataAndCount) => {
          const receivedData = dataAndCount as { rows: {}[], count: number };
          params.success({
            rowData: receivedData.rows,
            rowCount: receivedData.count
          });
        });
      }
    });
  }
}
